/*
Created Success Reducer to save questionnaire evaluation data
 */
export function questionnaireEvaluationSaveSuccessReducer(state, action) {
    return Object.assign(Object.assign({}, state), { isSaveSuccess: true });
}
//# sourceMappingURL=questionnaireEvaluationSaveSuccessReducer.js.map